var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1204_162)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 41.25,
    height: 38.5,
    rx: 7.33333,
    fill: "#ECECEC",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9571 25.6028L17.8975 24.2254C18.4206 23.8492 19.0083 23.5721 19.6314 23.4081C20.3583 23.2145 20.684 22.8173 20.684 21.9702C20.684 19.8202 25.6493 19.5918 25.6493 21.9702C25.6493 22.8173 25.975 23.2145 26.702 23.4072C27.3395 23.578 27.8936 23.8391 28.4358 24.2254L30.3763 25.6018C31.2531 26.2254 31.6623 26.5263 31.8897 27.006C32.1042 27.4568 32.1042 27.9851 32.1042 29.0417C32.1042 30.9425 32.1042 31.8928 31.5719 32.5016C30.9274 33.2394 29.2521 33.1768 28.2233 33.1768H18.11C17.0812 33.1768 15.4397 33.2791 14.7614 32.5016C14.2292 31.8928 14.2292 30.9425 14.2292 29.0417C14.2292 27.9851 14.2292 27.4568 14.4437 27.006C14.6721 26.5273 15.0792 26.2264 15.9571 25.6028Z",
    fill: "#2E5C33",
    stroke: "#2E5C33",
    strokeWidth: 1.48958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5711 29.6198C24.9435 29.2473 25.1528 28.7421 25.1528 28.2154C25.1528 27.6886 24.9435 27.1834 24.5711 26.811C24.1986 26.4385 23.6934 26.2292 23.1667 26.2292C22.6399 26.2292 22.1348 26.4385 21.7623 26.811C21.3898 27.1834 21.1806 27.6886 21.1806 28.2154C21.1806 28.7421 21.3898 29.2473 21.7623 29.6198C22.1348 29.9922 22.6399 30.2015 23.1667 30.2015C23.6934 30.2015 24.1986 29.9922 24.5711 29.6198Z",
    stroke: "white",
    strokeWidth: 1.48958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5323 17.1473C30.6704 16.5872 29.7289 16.1234 28.4201 15.75L28.9057 19.326C29.0914 20.6954 29.4062 21.1781 30.7438 21.5753C31.2016 21.7103 31.6634 21.8345 32.1232 21.9636C32.729 22.1324 33.2523 21.8206 33.3198 21.1691C33.4807 19.6289 32.8958 18.0331 31.5323 17.1473Z",
    fill: "#2E5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4101 15.75C17.1013 16.1234 16.1598 16.5872 15.2979 17.1473C13.9344 18.0331 13.3495 19.6289 13.5104 21.1691C13.5779 21.8206 14.1012 22.1324 14.707 21.9636C15.1678 21.8345 15.6285 21.7103 16.0863 21.5753C17.424 21.1781 17.7388 20.6954 17.9245 19.326L18.4101 15.75Z",
    fill: "#2E5C33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4101 15.75C17.1013 16.1234 16.1598 16.5872 15.2979 17.1473C13.9344 18.0331 13.3495 19.6289 13.5104 21.1691C13.5779 21.8206 14.1012 22.1324 14.707 21.9636C15.1678 21.8345 15.6285 21.7103 16.0863 21.5753C17.424 21.1781 17.7388 20.6954 17.9245 19.326L18.4101 15.75ZM18.4101 15.75C21.6465 14.8265 25.1837 14.8265 28.4201 15.75M28.4201 15.75C29.7289 16.1234 30.6704 16.5872 31.5323 17.1473C32.8958 18.0331 33.4807 19.6289 33.3198 21.1691C33.2523 21.8206 32.729 22.1324 32.1232 21.9636C31.6634 21.8345 31.2016 21.7103 30.7438 21.5753C29.4062 21.1781 29.0914 20.6954 28.9057 19.326L28.4201 15.75Z",
    stroke: "#2E5C33",
    strokeWidth: 1.48958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1204_162",
    x: 0.25,
    y: 0.333333,
    width: 55.9167,
    height: 53.1667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.58333,
    dy: 3.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1204_162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1204_162",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon1);
export default __webpack_public_path__ + "static/media/Telephone_icon 1.5a9d9276497fb405217eb8d73e073816.svg";
export { ForwardRef as ReactComponent };